export default "__VITE_ASSET__CKssZIzB__"